import { Jump } from './Jump';
export class Call extends Jump {
    constructor(pc) {
        super('CALL', pc);
    }
    plus(pc) {
        return new Call(this.pc.plus(pc));
    }
}

//# sourceMappingURL=Call.js.map
